import { lazy, Suspense } from 'react';
import { useLocation } from '../lib/router';
import { usePlayer } from '../state/player';
import { BottomNav } from '../components/BottomNav';
import { MiniPlayer } from '../features/music/MiniPlayer';
import { AuthPrompt } from '../features/auth/AuthPrompt';
import { matchLocation, Outlet } from './Outlet';
import styles from './shell.module.css';

const NowPlaying = lazy(() => import('../features/music/NowPlaying').then((m) => ({ default: m.NowPlaying })));

export function Shell() {
  const { pathname } = useLocation();
  const chrome = matchLocation(pathname)?.route.chrome ?? 'default';
  const hasTrack = usePlayer((s) => s.index >= 0);
  const expanded = usePlayer((s) => s.expanded);
  const showNav = chrome !== 'focus';

  return (
    <div className={styles.app} data-chrome={chrome} data-mini={hasTrack && showNav ? 'on' : 'off'}>
      <a href="#main" className={styles.skip}>
        Naar inhoud
      </a>
      <main id="main" className={styles.viewport}>
        <Outlet />
      </main>
      {hasTrack && showNav && <MiniPlayer />}
      {showNav && <BottomNav immersive={chrome === 'immersive'} />}
      {expanded && (
        <Suspense fallback={null}>
          <NowPlaying />
        </Suspense>
      )}
      <AuthPrompt />
    </div>
  );
}
